import fs from 'node:fs'
import path from 'node:path'

/** `config.paths.admin` arrives as `./cms` or `src/cms`; oxfmt wants a bare POSIX path. */
/** `create-next-app --no-linter` leaves the project without lint scripts. */
export function addLintScripts(cwd: string): void {
  const pkgPath = path.join(cwd, 'package.json')
  if (!fs.existsSync(pkgPath)) return

  const raw = fs.readFileSync(pkgPath, 'utf-8')
  let pkg: { scripts?: Record<string, string> }
  try {
    pkg = JSON.parse(raw)
  } catch {
    return
  }

  pkg.scripts = {
    ...pkg.scripts,
    lint: 'oxlint && oxfmt --check',
    // oxlint only applies non-overlapping fixes per pass, so an import with
    // several inline `type` specifiers needs one pass each; the trailing
    // `oxlint` reports whatever stayed unfixable.
    'lint:fix': 'for _ in 1 2 3 4 5; do oxlint --fix --silent && break; done; oxfmt && oxlint',
    format: 'oxfmt'
  }

  const newline = raw.includes('\r\n') ? '\r\n' : '\n'
  fs.writeFileSync(pkgPath, `${JSON.stringify(pkg, null, 2)}${newline}`, 'utf-8')
}
